import i18n from "i18next";
import {Card} from "@/Components/Card";
import {OrganizationLogoManagement} from "@/Components/Manage/OrganizationLogoManagement";
import EditOrgModal from "@/Pages/Manage/EditOrgModal";
import {AddSubOrganizationCard} from "@/Components/Manage/AddSubOrganization";
import React from "react";
import {usePage} from "@inertiajs/inertia-react";


export default function OrganizationInfoCard({props,
                                             state,
                                             dispatch,
                                             logoUrl,
                                             onFileUploaded}) {
    const isOwner = usePage().props ? usePage().props.auth.current_organization?.is_owner : false;
    const features = usePage().props.features;
    return (
        <Card dataTestid="organization_info" className="organization-info-card col">
            <div className="organization-card-header">
                <span className="organization-card-title">{i18n.t("admin-account-overview.organization-info")}</span>
                {/*<span className="edit-organization">
                    <i className="fas fa-cog"
                        onClick={() => dispatch({ type: "editOrgModal", payload: { editOrgModal: true }})}
                    />
                </span>*/}
            </div>
            <div className="organization-card-body">
                <div className="organization-card-subtitle">{i18n.t("admin-account-overview.name")}</div>
                <div className="organization-name">{props.organization.name}</div>
            </div>
            <div className="edit-organization-logo">
                {
                <OrganizationLogoManagement
                    organizationName={props.organization.name}
                    logoUrl={logoUrl}
                    onFileUploaded={onFileUploaded}
                ></OrganizationLogoManagement>
                }
            </div>
            { state.editOrgModal && <EditOrgModal props={props} state={state} dispatch={dispatch}/> }
            {isOwner && features['create_child_org'] ? <AddSubOrganizationCard/> : null}
        </Card>
    )
}
